module.exports = __webpack_public_path__ + "img/tu_hauptgebaeude_c_tu_wien_matthias_heisler-goemb.1e91beb9.jpg";